/**
 * Loyalty deals only in whole numbers: points, hold days and booking counts are
 * never fractional. The API can still return decimals (e.g. `100.0`) and users
 * can type anything, so every value rendered or submitted by the Loyalty views
 * goes through these helpers.
 *
 * Lives outside `const/` so the `UI/` components can import it without creating
 * a cycle (`const/index.ts` imports types from `UI/`).
 */

/** Truncates to a whole number, falling back to 0 for empty or non numeric input. */
export const toIntValue = (value: number | string): number => {
    const parsed = Number(value);

    return Number.isFinite(parsed) ? Math.trunc(parsed) : 0;
};

/** Whole number with thousands separators for display, e.g. 3220.6 -> "3,220". */
export const formatInt = (value: number | string): string => toIntValue(value).toLocaleString('en-US');

/** Whole number without separators, for input values, e.g. 100.0 -> "100". */
export const toIntInputValue = (value: number | string): string => String(toIntValue(value));

/** Keeps digits only so an input can never hold decimals, signs or spaces. */
export const sanitizeIntInput = (value: string): string => value.replace(/\D/g, '');
